import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ModalHeader = styled.div({
	font: token('font.heading.medium'),
	color: token('color.text'),
	paddingBottom: token('space.200'),
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > div': {
		cursor: 'pointer',
		height: '24px',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ModalDescription = styled.div({
	color: token('color.text'),
	paddingBottom: token('space.200'),
});
